import React, { useState, useEffect } from "react";
import { Col, Row, Button, InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link, useParams, useNavigate } from "react-router-dom";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditor from "react-froala-wysiwyg";

import Loader from "../Loader/Loader";
import swal from "sweetalert";
import NoDataText from "../NoDataText";

import { TableListApi } from "./../API/Communications/TableList";
import { EditTemplateName } from "../API/Communications/EmailTemplateName";
import { SaveNotify } from "../API/Communications/SaveNotify";

import SideBar from "../SideBar/SideBar";
import { MdKeyboardArrowLeft } from "react-icons/md";

import dropdownArrow from "../../assets/down arrow.png";
import { FroalaDefault } from "../../Utils/FroalaDefaultText";
import { FroalaTextEditor } from "../FroalaEditor/FroalaTextEditor";
import BackButton from "../BackButton/BackButton";

export const BusinessListingNotify = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [loading, setLoading] = useState(false);

  // onchange
  const [statusValue, setStatusValue] = useState("");
  const [categoryValue, setcategoryValue] = useState("");
  const [emailValue, setemailValue] = useState("");
  const [EmailSubjectValue, setEmailSubjectValue] = useState("");
  const [TemplateContent, setTemplateContent] = useState(FroalaDefault.text);

  // const TemplateOnload = <div><h1>hhjhnjjk</h1></div>

  // const regex = /(<([^>]+)>)/gi;
  //  const templatevalue = TemplateOnload.replace(regex, "");
  //  console.log(templatevalue,"templatevalue")

  const [EmailTemplate, setEmailTemplate] = useState([]);
  const [EmailSubject, setEmailSubject] = useState("");
  // err
  const [statusValueErr, setStatusValueErr] = useState("");
  const [categoryValueErr, setcategoryValueErr] = useState("");
  const [emailValueErr, setemailValueErr] = useState("");
  const [TempalteContentErr, setTempalteContentErr] = useState("");

  const [urlValue, setUrlValue] = useState([]);

  useEffect(() => {
    setLoading(true);
    ApiEmailTemplate();
    const ss = slug.split("-");
    setStatusValue(ss[1]);
    setcategoryValue(ss[2]);
    setUrlValue(ss);
  }, []);

  // TableListApi
  const ApiEmailTemplate = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
    };
    const res = await EditTemplateName(data, () => {
      navigate("/");
    });
    if (res.status === 429) {
      setLoading(true);
      swal({
        // title: "Error!",
        title: `${res.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else if (res == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (res.success === false) {
        setLoading(false);
      } else {
        setLoading(false);
        setEmailTemplate(res.data);
      }
    }
  };

  const handleTempalteChange = (model) => {
    setTemplateContent(model);
    if (model.length != 0) {
      setTempalteContentErr(false);
    }
  };

  // Image Upload froala
  const handleImageUpload = (e, editor, response) => {
    const imgSrc = response.link;

    // Insert the uploaded image into the editor
    editor.image.insert(imgSrc, false, null, editor.image.get(), null);

    // Update the editor content
    setTemplateContent(editor.html.get());
  };
  //

  const SaveHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (statusValue.length == 0) {
      setStatusValueErr(true);
      setLoading(false);
    }
    if (categoryValue.length == 0) {
      setcategoryValueErr(true);
      setLoading(false);
    }
    if (emailValue.length == 0) {
      setemailValueErr(true);
      setLoading(false);
    }
    if (TemplateContent.length == 0) {
      setTempalteContentErr(true);
      setLoading(false);
    }
    if (
      categoryValue.length != 0 &&
      emailValue.length != 0 &&
      TemplateContent.length != 0 &&
      statusValueErr == false &&
      categoryValueErr == false &&
      emailValueErr == false &&
      TempalteContentErr == false
    ) {
      setLoading(true);
      const cityId = localStorage.getItem("cityId");
      // const regex = /(<([^>]+)>)/gi;
      // console.log(typeof TemplateContent,"TemplateContent")
      // const newString = TemplateContent.replace(regex, "");
      const data = {
        user_id: parseInt(cityId),
        template_id: parseInt(emailValue),
        b_status: statusValue,
        category_id: [parseInt(urlValue[0])],
        email_subject: EmailSubject,
        email_content: TemplateContent,
        business_user_id: [parseInt(urlValue[3])],
      };
      const Response = await SaveNotify(data, () => {
        navigate("/");
      });
      if (Response.status === 429) {
        setLoading(true);
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
      } else if (Response === false) {
        swal({
          // title: "Error!",
          title: NoDataText.InternalErr,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        setLoading(false);
      } else {
        setLoading(false);
        if (Response.status == 404) {
          swal({
            text: `${Response.message}`,
            icon: "warning",
            buttons: "Ok",
            dangerMode: false,
          });
          setTimeout(() => {
            window.location.reload(false);
          }, 1000);
        } else {
          swal({
            // title: "Success!",
            title: `${Response.message}`,
            icon: "success",
            buttons: "OK",
            dangerMode: false,
          });
          setTimeout(() => {
            navigate("/business-listings/all-listings");
          }, 1000);
        }
      }
    }
  };

  const handleEmailTemplate = async (e) => {
    // console.log(e.target.value)
    setLoading(true);
    setemailValue(e.target.value);
    const cityId = localStorage.getItem("cityId");
    const data = {
      user_id: parseInt(cityId),
      template_id: e.target.value,
    };
    const coupondetailData = await TableListApi(data, () => {
      navigate("/");
    });
    if (coupondetailData.status === 429) {
      setLoading(true);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else if (coupondetailData.success === false) {
      setLoading(false);
      swal({
        text: `${coupondetailData.message}`,
        icon: "error",
        buttons: "Ok",
        dangerMode: false,
      });
    } else {
      setEmailSubject(coupondetailData.data[0].email_subject);
      setTemplateContent(coupondetailData.data[0].template_content);
      setemailValueErr(false);
      setLoading(false);
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Notify {urlValue[1]} </p>
          <div className="acc-dashboard mt-4">
            {/* <TabsSection /> */}
            <Row>
              <Col>
                <Form
                  // onSubmit={SaveHandler}
                  className="formmain mx-0 mt-4 signin-row profile-form pb-4"
                >
                  <Row className="notifyDisabled">
                    <Col md="6" className="notifyBus">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Business Name <span className="star-required"></span>
                        </Form.Label>
                        <InputGroup className="edit-border disabledNotify">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            value={statusValue}
                            // placeholder="Enter Email Subject"
                            maxLength={30}
                            className="custom-formcontrol"
                            style={{ cursor: "not-allowed" }}
                            disabled
                          />
                        </InputGroup>

                        {/* <Form.Select
                    aria-label="Default select example"
                    className="custom-select"
                    onChange={(e) => setStatusValue(e.target.value)}
                  >
                    <option>Select Business Status</option>
                    {bussinessStatus.map((i, k) => {
                      return (
                        <option value={i.business_status_id}>
                          {" "}
                          <Form.Check
                            aria-label="option 1"
                            className="orange-checkbox"
                          />
                          {i.business_status}
                        </option>
                      );
                    })}
                  </Form.Select> */}
                        {statusValueErr && (
                          <p style={{ color: "red" }}>
                            *Please select business status!
                          </p>
                        )}
                      </Form.Group>

                      {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                    </Col>
                    <Col md="6" className="notifyBus">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom ">
                          Business Category{" "}
                          <span className="star-required"></span>
                        </Form.Label>
                        <InputGroup className="edit-border disabledNotify">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            value={categoryValue}
                            // placeholder="Enter Email Subject"
                            maxLength={30}
                            className="custom-formcontrol"
                            style={{ cursor: "not-allowed" }}
                            disabled
                          />
                        </InputGroup>
                        {statusValueErr && (
                          <p style={{ color: "red" }}>
                            *Please select business category!
                          </p>
                        )}
                      </Form.Group>
                      {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                    </Col>
                    <Col md="6" className="">
                      <Form.Group
                        className="mb-4 emailTemplate"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          Email Template{" "}
                          <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          // className="custom-select dropdown-bulknotify ETemp"
                          className="custom-select dropdown-bulknotify"
                          onChange={(e) => handleEmailTemplate(e)}
                          style={{ cursor: "pointer" }}
                        >
                          <option key="blankChoice" className="disabledNotify">
                            Select Email template
                          </option>
                          {EmailTemplate.map((i, k) => {
                            return (
                              <option value={i.template_id}>
                                {i.template_name}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {emailValueErr && (
                          <p style={{ color: "red" }}>
                            *Please select Email template!
                          </p>
                        )}
                      </Form.Group>
                      {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                    </Col>
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Email Subject <span className="star-required"></span>
                        </Form.Label>
                        <InputGroup className="edit-border">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            value={EmailSubject}
                            placeholder="Enter Email Subject"
                            // maxLength={10}
                            className="custom-formcontrol"
                            style={{ cursor: "pointer" }}
                            readOnly
                          />
                        </InputGroup>
                        {/* <ErrorLabel ErrorDisplay={errDisplayLastName} /> */}
                      </Form.Group>
                    </Col>

                    <Col md="12" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom flex-content">
                          Template Content{" "}
                          <span className="star-required">*</span>
                          <p className="info-text-space-f-13">
                            &#40;To start from a new line, please press Shift +
                            Enter.&#41;
                          </p>
                        </Form.Label>
                        <FroalaTextEditor
                          TemplateContent={TemplateContent}
                          setTemplateContent={setTemplateContent}
                        />
                        {TempalteContentErr && (
                          <p style={{ color: "red" }}>
                            *Please add template content!
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-center small-btns d-flex">
                    <Link to="/business-listings/all-listings">
                      <p className="view mt-3" style={{ minWidth: "100px" }}>
                        Discard
                      </p>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                      onClick={SaveHandler}
                      style={{ minWidth: "100px" }}
                    >
                      Send
                    </Button>
                  </div>
                </Form>
              </Col>
            </Row>

            {/* end */}
          </div>
        </div>
      </div>
    </>
  );
};
